import angular from 'angular'
import snowballService from './snowball.service'
import snowballSuggests from './suggests.component'

export default angular
  .module('ellipsis.snowball', [])
  .service('snowballService', snowballService)
  .component('snowballSuggests', snowballSuggests)
